import {Component, EventEmitter,  Output, ViewChild} from '@angular/core';
import {
  PortNumberBlockDetails,
} from '../../port-phonenumber.model';
import {MessageService} from 'primeng/api';
import {I18NextService} from 'angular-i18next';
import {FormEmitter} from "../../../forms/form.component";
import { PortBlockNumberFormComponent } from "../../../forms/port-block-number-form/port-block-number-form.component";

@Component({
    selector: 'app-phonenumber-port-block',
    templateUrl: './phonenumber-port-block.component.html',
    standalone: false
})
export class PhonenumberPortBlockComponent {
  @Output() public readonly selected = new EventEmitter<PortNumberBlockDetails[]>();
  @Output() public readonly onBack = new EventEmitter();

  public formData: PortNumberBlockDetails;
  public isFormValid: boolean = false;

  @ViewChild(PortBlockNumberFormComponent) portBlockForm: PortBlockNumberFormComponent;

  constructor(public messageService: MessageService,
              public i18next: I18NextService) {
  }

  back() {
    this.onBack.emit();
  }

  onFormChanged(form: FormEmitter<PortNumberBlockDetails>) {
    this.isFormValid = form.formGroup.valid;
    this.formData = form.data;
  }

  public onNext() {
    if (!this.isFormValid) return;
    if (!this.portBlockForm.validate()) return;
    this.selected.emit([this.formData]);
  }
}
